import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import type { BillingMethod, GroupId } from 'balus-common';
import { trpcClient } from '@framework/trpcClient';

export const useGroupBillingMethod = (groupId: GroupId): BillingMethod | null => {
  const [result, setResult] = useState<{ groupId: GroupId; billingMethod: BillingMethod | null }>();

  useEffect(() => {
    let active = true;
    setResult(undefined);
    trpcClient.group.getGroupBillingMethod
      .query({ groupId })
      .then(({ billingMethod }) => {
        if (active) setResult({ groupId, billingMethod });
      })
      .catch((error: unknown) => {
        Sentry.captureException(error);
      });
    return () => {
      active = false;
    };
  }, [groupId]);

  return result?.groupId === groupId ? result.billingMethod : null;
};
